const getUserImage = function(userImage)
{
	var imageReturn = "./images/default_avatar.svg";
	if ( userImage && userImage.indexOf('.s3') > -1 ) { imageReturn = userImage; }
	
	return imageReturn;
}

export { getUserImage };